import CTAButton from "../../CTAButton";
import { LocalizationMessages } from "../../../localization/messages";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { UserContextSelectors } from "../../../redux/selectors";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import LoginCTAButton from "../../LoginCTAButton";
import styled from "styled-components";
import { GeneralUtils, PageContextUtils } from "../../../utils";
import { BrandUtils } from "../../../utils/brandUtils";

const BalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  top: 6px;
  left: 22px;
`;

const BalanceValue = styled.span`
  font-family: ${props => props.theme.typography.fontFamilyBold};
`;
const BalanceValueSecondary = styled.span`
  font-family: ${props => props.theme.typography.fontFamily};
`;
const AccountDashboardButtons = ({
  handleCashier,
  handleLogin,
  trackingInfo
}) => {
  const { formatMessage } = useIntl();
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const userBalance = useSelector(UserContextSelectors.userBalance);
  const userBalanceNumber = useSelector(UserContextSelectors.userBalanceNumber);
  const { currency, culture, exchangeRateToUSD } =
    PageContextUtils.getLocalizationData();

  const buttonProps = {
    btnContext: "leftPanel",
    type: isAuthenticated ? "UserBalance" : "Login",
    onClick: isAuthenticated ? handleCashier : handleLogin,
    title: !isAuthenticated && formatMessage(LocalizationMessages.login),
    aCclassName: isAuthenticated ? "aCcashierButton" : "aCloginButton",
    trackingInfo
  };

  const userBalanceUSD = useMemo(() => {
    if (exchangeRateToUSD && BrandUtils.isPokerClient() && currency !== "USD") {
      return GeneralUtils.formatAmount(
        userBalanceNumber * exchangeRateToUSD,
        culture,
        "USD"
      );
    }
  }, [userBalanceNumber, culture, currency, exchangeRateToUSD]);

  return (
    <>
      {isAuthenticated && (
        <CTAButton {...buttonProps}>
          {userBalanceUSD ? (
            <BalanceWrapper>
              <BalanceValue data-testid="uc-current-balance-primary-deposit-button">
                {userBalanceUSD}
              </BalanceValue>
              <BalanceValueSecondary data-testid="uc-current-balance-secondary-deposit-button">
                ({userBalance})
              </BalanceValueSecondary>
            </BalanceWrapper>
          ) : (
            <BalanceWrapper>
              <BalanceValue data-testid="uc-current-balance-deposit-button">
                {userBalance}
              </BalanceValue>
            </BalanceWrapper>
          )}
        </CTAButton>
      )}
      {!isAuthenticated && <LoginCTAButton {...buttonProps} />}
    </>
  );
};

AccountDashboardButtons.propTypes = {
  handleCashier: PropTypes.func,
  handleLogin: PropTypes.func,
  trackingInfo: PropTypes.object
};

export default React.memo(AccountDashboardButtons);
